<template>
    <div class="home-model-content">
        <div class="home-model-content-header">
            <h1 class="table-title">3D Models</h1>
            <b-field class="table-search">
                <b-input v-model="searchQuery" placeholder="Search..."  type="search" icon="magnify" rounded> </b-input>
            </b-field>
            <b-tooltip label="Delete multiple items" class="delete-models"
                       type="is-dark" position="is-bottom">
                <i class="em em-no_entry" @click="confirmDeleteMultipleModel"></i>
            </b-tooltip>
            <!-- <b-tooltip label="Settings for table" class="cursor-pointer"
                       type="is-dark" position="is-bottom">
                <i class="em em-gear" ></i>
            </b-tooltip> -->
        </div>

        <!--@details-open="(row, index) => $toast.open(`Expanded ${row.name}`)"-->
        <div class="home-model-content-table" id="v-step-0-9">
            <b-table
                    :data="filter"
                    :loading="loading"
                    :striped="isStriped"
                    :narrowed="isNarrowed"
                    :hoverable="isHoverable"
                    :checked-rows.sync="checkedRows"
                    checkable
                    sortable
                    paginated
                    :per-page="perPage"
                    ref="table"
                    :opened-detailed="defaultOpenedDetails"
                    :mobile-cards="hasMobileCards"
                    detailed
                    detail-key="name"
                    :show-detail-icon="showDetailIcon">

                <template slot-scope="props" slot="header">
                    <span class="table-header-color"> {{ props.column.label }}</span>
                </template>

                <template slot-scope="props">
                    <b-table-column field="model_numb" label="#" width="40" numeric >
                        <!--{{ props.row.id }}-->
                        {{ props.row.model_numb }}
                    </b-table-column>

                    <b-table-column field="name" label="Name" sortable>
                        <template v-if="showDetailIcon">
                            {{ truncate(props.row.name, 17) }}
                        </template>
                        <template v-else>
                            <a @click="toggle(props.row)">
                                {{ truncate(props.row.name, 17) }}
                            </a>
                        </template>
                    </b-table-column>

                    <b-table-column field="extension" label="Extension" sortable centered>
                        {{ getModelExtension(props.row.name) }}
                    </b-table-column>
                    <b-table-column field="Category" label="Category" sortable centered>
                        <div v-if="props.row.category">{{ props.row.category }}</div>
                        <div v-else>Others</div>
                        
                    </b-table-column>

                    <b-table-column field="size" label="Size" sortable centered>
                        {{ Math.round(props.row.size * 100) / 100 }} MB
                    </b-table-column>

                    <b-table-column field="created_at" label="Date" sortable>
                        {{ new Date(props.row.created_at).toLocaleDateString() }}
                    </b-table-column>
                    <b-table-column field="app_access" label="On App" sortable centered>
                        <b-checkbox v-if="props.row.app_access" v-model="props.row.app_access" type="is-success" @input="updateOnApp('false', props.row.id)"> </b-checkbox>
                        <b-checkbox v-else v-model="props.row.app_access" type="is-success" @input="updateOnApp('true', props.row.id)"> </b-checkbox>
                    </b-table-column>

                    <b-table-column label="Action" centered id="v-step-0-13">

                        <span > <a :href="props.row.model_file"><b-icon icon="download" type="is-success" class=" actions cursor-pointer"></b-icon></a> </span>
                        <span >
                            <a target="_blank" :href="createURL(props.row.model_file, props.row.name, props.row.id)">
                                <b-icon icon="pencil" type="is-primary" class="actions cursor-pointer" > </b-icon>
                            </a>
                        </span>
                        <!-- <span >
                            <a target="_blank" :href="createURL(props.row.model_file, props.row.name, props.row.id)">
                                <b-icon icon="eye" type="is-primary" class="actions cursor-pointer" > </b-icon>
                            </a>
                        </span> -->

                        <span @click="confirmDeleteOneModel(props.row)"><b-icon icon="delete-forever" type="is-danger" class="cursor-pointer" > </b-icon></span>
                    </b-table-column>

                </template>

                <template slot="detail" slot-scope="props">
                    <div class="details">
                        <!--<div class="file-icon">-->
                            <!--<img src="https://buefy.github.io/static/img/placeholder-128x128.png">-->
                        <!--</div>-->
                        <div class="file-details">
                            <div>
                                <h2>Unit</h2>
                                <h1>{{ getUnit(props.row.meta.measure_unit) }} </h1>
                            </div>
                            <div >
                                <h2>Low Poly</h2>
                                <h1 v-if="props.row.meta.low_poly_ready" >Yes</h1>
                                <h1 v-else>No</h1>
                            </div>
                            <div >
                                <h2>Axis Up</h2>
                                <h1>{{props.row.meta.axis_up }}</h1>
                            </div>
                            <div>
                                <h2>Description</h2>
                                <h1>{{ props.row.description }}</h1>
                            </div>
                        </div>
                    </div>
                </template>

                <template slot="empty">
                    <section class="section cursor-pointer" @click="openUploadModels()">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon
                                        icon="emoticon-sad"
                                        size="is-large">
                                </b-icon>
                            </p>
                            <p>No Models uploaded yet. <br /> <br /> Click to upload models</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </div>

</template>

<script>
    export default {
        name: "HomeModelContent",
        data() {
            return {
                searchQuery: '',
                isStriped: true,
                isNarrowed: false,
                isHoverable: false,
                isFocusable: false,
                isLoading: false,
                hasMobileCards: false,
                perPage: 10,

                checkedRows: [],
                rowToDelete: [],

                total: 0,
                loading: false,
                page: 1,
                counter: 0,
                defaultOpenedDetails: [2,3],
                showDetailIcon: true
            }
        },
        computed: {
            tableData() {
                return this.$store.getters.getAllUserModels;
            },
            filter: function () {
                let name_re = new RegExp(this.searchQuery, 'i');
                let data = [];
                for (let i in this.$store.getters.getAllUserModels) {
                    if (this.$store.getters.getAllUserModels[i].name.match(name_re) || this.$store.getters.getAllUserModels[i].description.match(name_re)) {
                        data.push(this.$store.getters.getAllUserModels[i])
                    }
                    // if (this.$store.getters.getAllUserModels[i].name.match(name_re) || 
                    //     this.$store.getters.getAllUserModels[i].description.match(name_re) ||
                    //     this.$store.getters.getAllUserModels[i].category.match(name_re)) {
                    //     data.push(this.$store.getters.getAllUserModels[i])
                    // }
                }

                for(let i =0; i< data.length; i++){
                    data[i].model_numb = i+1;
                }
                return data
            },
        },
        mounted() {
            this.loadModels();
        },
        methods: {
            loadModels() {
                this.$store.dispatch('downloadAllUserModelsFromServer')
                    .then(() => {
                        console.log("success - model loaded")
                    })
                    .catch(() => {
                        console.log("failed- model not loaded")
                    })
            },
            toggle(row) {
                this.$refs.table.toggleDetails(row)
            },
            getModelExtension(modelName) {
                let ext = modelName.substr(modelName.lastIndexOf('.') + 1) === modelName ? '-' : modelName.substr(modelName.lastIndexOf('.') + 1);
                return ext.toUpperCase();
            },
            openUploadModels() {
                this.$store.dispatch('setCurrentTab', 1);
            },
            confirmDeleteOneModel(row) {
                console.log("clicked!", row)
                this.$dialog.confirm({
                    title: 'Deleting Models',
                    message: 'Are you sure you want to <b>delete</b> the selected model? This action cannot be undone.',
                    confirmText: 'Delete',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteModel(row)
                });
            },
            confirmDeleteMultipleModel() {
                if(this.checkedRows.length>0){
                    this.$dialog.confirm({
                        title: 'Deleting Models',
                        message: 'Are you sure you want to <b>delete ' + this.checkedRows.length + ' </b> model(s)? This action cannot be undone.',
                        confirmText: 'Delete',
                        type: 'is-danger',
                        hasIcon: true,
                        onConfirm: () => this.deleteModels()
                    });
                }
            },
            deleteModel(row) {
                this.$store.dispatch('deleteModelsFromServer', row)
                    .then(() => {
                        console.log("success - model deleted")
                    })
                    .catch(() => {
                        console.log("failed- model not deleted")
                    })
            },
            deleteModels() {
                for (let i = 0; i < this.checkedRows.length; i++) {
                    this.$store.dispatch('deleteModelsFromServer', this.checkedRows[i])
                        .then(() => {
                            console.log("success - model deleted")
                        })
                        .catch(() => {
                            console.log("failed- model not deleted")
                        })
                }
                this.checkedRows = []
            },
            truncate(value, length) {
                return value.length > length
                    ? value.substr(0, length) + '...'
                    : value
            },
            createURL(url, name, id) {
                // return "http://localhost:9000/ainakviewer.html?url=" + url + "&name=" + name + "&token=" + this.$store.state._token + "&id=" + id;
                //return "https://ainakeu-editor.web.app/ainakviewer.html?url=" + url + "&name=" + name + "&token=" + this.$store.state._token + "&id=" + id;
                
                return "https://ainakeu-editor.web.app/ainakeditor.html?url=" + url + "&name=" + name + "&token=" + this.$store.state._token + "&id=" + id;

                //return "http://localhost:9000/ainakeditor.html?url=" + url + "&name=" + name + "&token=" + this.$store.state._token + "&id=" + id;
                // return "https://ainak-editor.firebaseapp.com/ainakeditor.html?url=" + url + "&name=" + name + "&token=" + this.$store.state._token + "&id=" + id;
                //return "https://ainak-editor.firebaseapp.com/ainakeditor.html?url=" + url + "&name=" + name + "&token=" + this.$store.state._token + "&id=" + id;
            },
            getUnit(unit){
                switch (unit) {
                    case 'm':
                        return 'Meters (M)'
                    case 'cm':
                        return 'Centimeter (CM)'
                    case 'in':
                        return 'Inches (IN)'
                    case 'mm':
                        return 'Millimeters (M)'
                    default:
                        return unit

                }
            },
           updateOnApp(status, id){
                console.log("my id of th model",id , status);
               this.$store.dispatch('updateAppAccess', {'id':id, 'app_access':status})
                   .then(() => {
                       console.log("success app access - updated")
                   })
                   .catch(() => {
                       console.log("failed- app access not updated")
                   })
           }
        }
    }
</script>


<style lang="scss" scoped>

   @import "@/assets/css/colors.scss";

    .home-model-content{
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .home-model-content-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: white;
        padding: 2%;
        margin-bottom: 0%;
        border-bottom: 1px solid #ccc;
    }
    .table-title{
        flex: 1;
        text-align: left;
        font-family: 'Roboto Slab', sans-serif;
        font-size: 150%;
        font-weight: normal;
        color: $primary-color;
    }
    .table-search{
        font-family: 'Roboto', sans-serif;
        font-size: 100%;
        border-radius: 1%;
        margin: 0 0 0 1%;
    }
    .delete-models{
        margin: 0  3% 0 1%;
        cursor: pointer;
    }

    .home-model-content-table{
    }

    .actions {
        margin : 0 10px 0 0;
    }
    .cursor-pointer {
        cursor: pointer;
    }

    .table-header-color{
        color: $primary_color;
    }

    .details {
        display: flex;
        align-content: center;
        flex-direction: row;

        .file-details {
            display: flex;
            align-content: center;
            flex-direction: row;
            width: 100%;

            div {
                margin-left: 5%;

                h2 {
                    text-align: left;
                    font-family: 'Roboto Slab', sans-serif;
                    font-size: 100%;
                    font-weight: normal;
                    color: $primary-color;
                }

                h1 {
                    text-align: left;
                    font-family: 'Roboto', sans-serif;
                    font-size: 100%;
                    font-weight: lighter;
                    color: $body-text-color;
                }
            }

            div:last-child{
                flex: 1;
            }
        }
    }
</style>